import request from 'lib/request';

export interface Response {
  code: number;
  msg: string;
  data:null;
}

export async function untrackProject(id: number) {
  const res = await request<Response>('/project/untrack', {
    method: 'POST',
    data:{
      id
    }
  });
  return res;
}
